module.exports = __webpack_public_path__ + "img/face-wink.8d004c72.svg";